import React from 'react';
import { Tooltip } from '@mui/material';

interface LoadingDisableWrapperProps {
    loading: boolean;
    message?: string;
    children: React.ReactElement;
}

const LoadingDisableWrapper: React.FC<LoadingDisableWrapperProps> = ({
    loading,
    message = 'Please wait, data is loading...',
    children,
}) => {
    return (
        <Tooltip title={loading ? message : ''} arrow>
            <span style={{ display: 'inline-block' }}>
                {children}
            </span>
        </Tooltip>
    );
};

export default LoadingDisableWrapper;